<script setup>
import { computed, inject } from 'vue';

const I18n = inject('I18n');

const props = defineProps({
  nodosSeleccionMostrados: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  buttonLabel: { type: String, default: undefined },
});

const emit = defineEmits(['abrir']);

const labelPlaceholder = computed(() => {
  if (props.buttonLabel !== undefined) {
    return props.buttonLabel;
  }
  return I18n.t('Estructura_escolar');
});

</script>

<template>
  <div class="input-group w-100 selector-estructura-display">
    <div
      class="form-control"
      role="button"
      :class="{ 'cursor-pointer': !disabled && !loading, disabled: disabled || loading }"
      @click="!disabled && !loading && emit('abrir')"
    >
      <template v-if="nodosSeleccionMostrados.length">
        <span
          v-for="node in nodosSeleccionMostrados"
          :key="`${node.type}-${node.id}`"
          class="label label-default me-1"
        >
          {{ node.nombre || node.etiqueta || node.label }}
        </span>
      </template>
      <template v-else>
        <span class="selector-placeholder text-muted">{{ labelPlaceholder }}</span>
      </template>
    </div>
    <div class="input-group-btn">
      <button
        type="button"
        class="btn btn-cifra"
        :disabled="disabled || loading"
        @click="emit('abrir')"
      >
        <i class="fa fa-folder-tree"></i>
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.selector-estructura-display .form-control.cursor-pointer {
  cursor: pointer;
}

.selector-estructura-display .form-control.disabled {
  cursor: not-allowed;
}
</style>
